<template>
    <v-container grid-list-md fluid>
        <v-row no-gutters>
            <v-col cols="12">
                <v-card class="default_card large">
                    <v-data-table-server
                        :headers="headers"
                        :items="items"
                        v-model:page="pagination.page"
                        v-model:sort-by="pagination.sortBy"
                        v-model:items-per-page="pagination.rowsPerPage"
                        :loading="loading"
                        :items-length="tagCount"
                        class="table"
                        fixed-header
                        max-height="60vh"
                    >
                        <template #item="props">
                            <tr>
                                <td class="text-left">{{ props.item.name }}</td>
                                <td class="text-left">{{ props.item.shortName }}</td>
                                <td class="text-left">{{ props.item.type }}</td>
                            </tr>
                        </template>
                    </v-data-table-server>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";

import TAGS from "../../graphql/Tags.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class Tags extends Vue {
    headers: Array<any> = [
        { title: "Name", value: "name" },
        { title: "Short name", value: "shortName" },
        { title: "Type", value: "type", sortable: false },
    ];

    pagination: any = {
        page: 1,
        rowsPerPage: 10,
        sortBy: [{ key: "name" }],
    };

    loading: boolean = true;

    tagCount = 0;

    @Apollo({
        query: TAGS,
        variables() {
            debugger;
            return {
                first: this.pagination.rowsPerPage,
                skip: (this.pagination.page - 1) * this.pagination.rowsPerPage,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            debugger;
            if (!loading && data) {
                debugger;
                this.items = data.tags;
                this.tagCount = data.tagsConnection.aggregate.count;
            }
        },
    })
    items: Array<any> = [];
}

export default toNative(Tags);
</script>
